(function() {
  'use strict';

  const PlaqueModule = {
    initialized: false,
    getConfig() {
      return {
        maxSlots: window.CF?.CONSTANTS?.MAX_SLOTS || 1,
        gallery: window.CF?.CONSTANTS?.PLAQUE_GALLERY || {},
        modal: window.CF?.CONSTANTS?.PLAQUE_MODAL || {}
      };
    }
  };

  // ============================================================================
  // UTILITY FUNCTIONS
  // ============================================================================

  function getVariantForSlot(i) {
    const sel = document.getElementById(`City${i}`);
    if (!sel || !sel.value) return null;
    return window.CF_VARIANT_LOOKUP?.byId?.[String(sel.value)] || null;
  }

  function stripFlagEmoji(str) {
    return str.replace(/[\u{1F1E6}-\u{1F1FF}]/gu, '').trim();
  }

  function isArabic(text) {
    return /[\u0600-\u06FF]/.test(text);
  }

  function getActiveCityCount() {
    const maxSlots = PlaqueModule.getConfig().maxSlots;
    let count = 0;
    for (let i = 1; i <= maxSlots; i++) {
      const sel = document.getElementById(`City${i}`);
      if (sel && sel.value && sel.value !== "") count++;
    }
    return Math.max(count, 1);
  }

  // ============================================================================
  // PREVIEW RENDERING (Designer Modal & Small Preview Badges)
  // ============================================================================

  function updatePlaqueModalPreview(cityIndex) {
    const headlineInput = document.getElementById(`plaque-note-${cityIndex}`);
    const subInput = document.getElementById(`plaque-subnote-${cityIndex}`);
    const wrappers = document.querySelectorAll(
      `#plaque-preview-cityname-${cityIndex}, #modal-plaque-${cityIndex} .plaque-modal-container`
    );

    if (!headlineInput || wrappers.length === 0) return;

    wrappers.forEach(wrapper => {
      let overlay = wrapper.querySelector('.plaque-modal-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'plaque-modal-overlay';
        wrapper.appendChild(overlay);
      }
      overlay.innerHTML = '';

      const widthPx = wrapper.clientWidth;
      const headlineSize = widthPx * 0.06;
      const subSize = widthPx * 0.03;

      const rawHeadline = headlineInput.value.trim();
      const previewHeadline = rawHeadline.toUpperCase().replace(/❤️|❤|♥/g, '♡');
      
      const h = document.createElement('span');
      h.textContent = previewHeadline;
      h.style.fontSize = `${headlineSize}px`;
      h.style.fontWeight = 'bold';
      h.style.textTransform = 'uppercase';
      h.style.color = '#3d3d3d';
      h.style.lineHeight = '1';

      if (isArabic(rawHeadline)) {
        h.style.direction = 'rtl';
        h.style.transform = 'translateY(-12%)';
      }
      overlay.appendChild(h);

      if (subInput && subInput.value.trim()) {
        const rawSub = subInput.value.trim();
        const previewSub = rawSub.toUpperCase().replace(/❤️|❤|♥/g, '♡');
        
        const s = document.createElement('span');
        s.textContent = previewSub;
        s.style.fontSize = `${subSize}px`;
        s.style.lineHeight = '1';
        s.style.textTransform = 'uppercase';
        s.style.color = '#3d3d3d';
        s.style.marginTop = '2px';
        overlay.appendChild(s);
      }
    });
  }

  // ============================================================================
  // SYNC TO GALLERY & ZOOM MODAL (Main Displays)
  // ============================================================================

  function syncPlaqueTextToGallery() {
    const enabled = !document.getElementById('addon-plaque-id')?.disabled;
    if (!enabled) return;

    // TARGET: 1. New Carousel Slides, 2. Old static slides, 3. The New Zoom Modal Wrapper
    const wrappers = document.querySelectorAll('.cc_city-preview-wrapper, .city-preview-wrapper, #mag-stage-wrapper');
    
    wrappers.forEach(w => {
      // Determine city index: Zoom modal (#mag-stage-wrapper) always uses City 1.
      // Gallery slides use their data-city-index.
      let idx = parseInt(w.dataset.cityIndex || '0', 10);
      if (w.id === 'mag-stage-wrapper') idx = 1; 

      // In the new gallery setup, we only show plaque on the first slide (Variant)
      // but in the Zoom modal, we always show it.
      if (w.classList.contains('cc_city-preview-wrapper') && idx !== 1) return;

      const plaque = w.querySelector('.plaque-overlay');
      if (!plaque) return;

      const inner = plaque.querySelector('.plaque-overlay-inner');
      if (!inner) return;

      const headlineInput = document.getElementById(`plaque-note-${idx}`);
      const subInput = document.getElementById(`plaque-subnote-${idx}`);
      
      inner.innerHTML = '';

      // Use actual plaque container width for font math
      const widthPx = plaque.clientWidth || 150;
      const headlineSize = widthPx * 0.06;
      const subSize = widthPx * 0.03;

      const rawHeadline = headlineInput?.value.trim() || '';
      const previewHeadline = rawHeadline.toUpperCase().replace(/❤️|❤|♥/g, '♡');

      const h = document.createElement('span');
      h.className = 'plaque-text-head';
      h.textContent = previewHeadline;
      h.style.fontSize = `${headlineSize}px`;
      h.style.fontWeight = 'bold';
      h.style.lineHeight = '1';
      h.style.textTransform = 'uppercase';
      h.style.color = '#3d3d3d';
      inner.appendChild(h);

      if (subInput && subInput.value.trim()) {
        const rawSub = subInput.value.trim();
        const previewSub = rawSub.toUpperCase().replace(/❤️|❤|♥/g, '♡');
        const s = document.createElement('span');
        s.className = 'plaque-text-sub';
        s.textContent = previewSub;
        s.style.fontSize = `${subSize}px`;
        s.style.lineHeight = '1';
        s.style.textTransform = 'uppercase';
        s.style.color = '#3d3d3d';
        s.style.marginTop = '1px';
        inner.appendChild(s);
      }

      // Handle character scaling (SQUISHING) so text fits metal plate
      requestAnimationFrame(() => {
        const maxW = plaque.clientWidth;
        if (!maxW) return;
        const headEl = inner.querySelector('.plaque-text-head');
        const subEl = inner.querySelector('.plaque-text-sub');
        if (!headEl) return;

        headEl.style.transform = '';
        if (subEl) subEl.style.transform = '';

        const wHead = headEl.offsetWidth;
        const wSub = subEl ? subEl.offsetWidth : 0;
        const widest = Math.max(wHead, wSub);
        
        if (widest > maxW && widest > 0) {
          const scale = (maxW / widest) * 0.95;
          inner.style.transform = `scale(${scale})`;
          inner.style.transformOrigin = 'center';
        } else {
          inner.style.transform = '';
        }
      });
    });
  }

  function syncPlaquePreviewVisibility(activeCount) {
    const plaqueEnabled = !document.getElementById('addon-plaque-id')?.disabled;
    for (let i = 1; i <= 6; i++) {
      const container = document.querySelector(`.preview-container-${i}`);
      if (container) {
        container.style.display = (plaqueEnabled && i <= activeCount) ? '' : 'none';
      }
    }
  }

  // ============================================================================
  // EMOJI & SYMBOL VALIDATION
  // ============================================================================

  function validatePlaqueInput(input) {
    const originalValue = input.value;
    let protectedValue = originalValue
      .replace(/❤️/g, '___HEART_EMOJI___')
      .replace(/❤/g, '___HEART_CHAR___')
      .replace(/♥/g, '___HEART_PLAIN___');

    let cleaned = protectedValue
      .replace(/[\u{1F600}-\u{1F64F}]/gu, '')
      .replace(/[\u{1F300}-\u{1F5FF}]/gu, '')
      .replace(/[\u{1F680}-\u{1F6FF}]/gu, '')
      .replace(/[\u{1F1E0}-\u{1F1FF}]/gu, '')
      .replace(/[\u{1F900}-\u{1F9FF}]/gu, '')
      .replace(/[\u{1FA00}-\u{1FAFF}]/gu, '')
      .replace(/[\u{2600}-\u{26FF}]/gu, '')
      .replace(/[\u{2700}-\u{27BF}]/gu, '')
      .replace(/[\u{FE00}-\u{FE0F}]/gu, '')
      .replace(/\|/g, '');

    cleaned = cleaned
      .replace(/___HEART_EMOJI___/g, '❤️')
      .replace(/___HEART_CHAR___/g, '❤')
      .replace(/___HEART_PLAIN___/g, '♥');

    if (originalValue.replace(/❤️|❤|♥/g, '') !== cleaned.replace(/❤️|❤|♥/g, '')) {
      input.value = cleaned;
      showPlaqueError(input);
      return false;
    }
    return true;
  }

  function showPlaqueError(inputElement) {
    let popup = document.getElementById('plaque-error-popup');
    if (!popup) {
      popup = document.createElement('div');
      popup.id = 'plaque-error-popup';
      Object.assign(popup.style, {
        position: 'fixed', backgroundColor: '#fff', color: '#333',
        padding: '12px 16px', borderRadius: '8px', boxShadow: '0px 4px 16px rgba(0,0,0,0.15)',
        border: '1px solid #e5e5e5', fontSize: '13px', zIndex: '999999', pointerEvents: 'none'
      });
      popup.textContent = 'Emojis (except ❤️) or symbols cannot be added.';
      document.body.appendChild(popup);
    }
    const rect = inputElement.getBoundingClientRect();
    popup.style.left = `${rect.left}px`;
    popup.style.top = `${rect.bottom + 8}px`;
    popup.style.display = 'block';
    setTimeout(() => { popup.style.display = 'none'; }, 3000);
  }

  // ============================================================================
  // AUTO-FILL & EVENTS
  // ============================================================================

  function applyAutoFill() {
    const autoHeadEl = document.getElementById('auto-headline');
    const autoSubEl = document.getElementById('auto-subheadline');
    if (!autoHeadEl || !autoSubEl) return;

    const active = getActiveCityCount();
    for (let i = 1; i <= active; i++) {
      const v = getVariantForSlot(i);
      const hIn = document.getElementById(`plaque-note-${i}`);
      const sIn = document.getElementById(`plaque-subnote-${i}`);
      if (!hIn || !sIn || !v) continue;

      if (autoHeadEl.value === 'cityname') hIn.value = v.baseCity || '';
      if (autoHeadEl.value === 'cityname_local') hIn.value = v.localname || v.baseCity || '';
      if (autoHeadEl.value === 'cityname_english') hIn.value = v.englishName || v.baseCity || '';
      if (autoHeadEl.value === 'countryname') hIn.value = stripFlagEmoji(v.countryname || '');
      if (autoHeadEl.value === 'cityname+countrycode') hIn.value = v.baseCity ? `${v.baseCity}, ${v.countrycode || ''}`.trim() : '';

      if (autoSubEl.value === 'cityname') sIn.value = v.baseCity || '';
      if (autoSubEl.value === 'cityname_local') sIn.value = v.localname || v.baseCity || '';
      if (autoSubEl.value === 'cityname_english') sIn.value = v.englishName || v.baseCity || '';
      if (autoSubEl.value === 'countryname') sIn.value = stripFlagEmoji(v.countryname || '');
      if (autoSubEl.value === 'areaname') sIn.value = v.variantCity || '';
      if (autoSubEl.value === 'coordinates') sIn.value = v.coordinates || '';
      if (autoSubEl.value === 'scale') sIn.value = v.scale || '';
      if (autoSubEl.value === 'none') sIn.value = '';

      updatePlaqueModalPreview(i);
    }
    syncPlaqueTextToGallery();
  }

  function bindEventHandlers() {
    for (let i = 1; i <= 6; i++) {
      const hIn = document.getElementById(`plaque-note-${i}`);
      const sIn = document.getElementById(`plaque-subnote-${i}`);
      if (hIn) hIn.addEventListener('input', () => { validatePlaqueInput(hIn); updatePlaqueModalPreview(i); syncPlaqueTextToGallery(); });
      if (sIn) sIn.addEventListener('input', () => { validatePlaqueInput(sIn); updatePlaqueModalPreview(i); syncPlaqueTextToGallery(); });
    }
    const ah = document.getElementById('auto-headline');
    const as = document.getElementById('auto-subheadline');
    if (ah) ah.addEventListener('change', applyAutoFill);
    if (as) as.addEventListener('change', applyAutoFill);
  }

  window.CFPlaque = {
    init() {
      if (PlaqueModule.initialized) return;
      bindEventHandlers();
      const designBtn = document.getElementById('plaque-design-btn');
      if (designBtn) designBtn.addEventListener('click', () => {
        setTimeout(() => {
          const count = getActiveCityCount();
          syncPlaquePreviewVisibility(count);
          updatePlaqueModalPreview(1);
        }, 50);
      });
      PlaqueModule.initialized = true;
    },
    updatePreview: (i) => updatePlaqueModalPreview(i),
    syncToGallery: () => syncPlaqueTextToGallery(),
    updateVisibility: (count) => syncPlaquePreviewVisibility(count),
    applyAutoFill: () => applyAutoFill(),
    getGalleryConfig: (size, isMobile) => PlaqueModule.getConfig().gallery[isMobile ? 'mobile' : 'desktop'] || {}
  };

  console.log('✓ CFPlaque module loaded');
})();